import { render, staticRenderFns } from "./BackgroundImageConfiguration.vue?vue&type=template&id=2eea759b&scoped=true"
import script from "./BackgroundImageConfiguration.vue?vue&type=script&lang=js"
export * from "./BackgroundImageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BackgroundImageConfiguration.vue?vue&type=style&index=0&id=2eea759b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea759b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eea759b')) {
      api.createRecord('2eea759b', component.options)
    } else {
      api.reload('2eea759b', component.options)
    }
    module.hot.accept("./BackgroundImageConfiguration.vue?vue&type=template&id=2eea759b&scoped=true", function () {
      api.rerender('2eea759b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/BackgroundImageConfiguration.vue"
export default component.exports